module.exports = "/assets/images/b4958e303eb64f6a6e86140c93ae40e1.jpg";